import { render, staticRenderFns } from "./EditableTableFooter.vue?vue&type=template&id=61b10961&"
import script from "./EditableTableFooter.vue?vue&type=script&lang=js&"
export * from "./EditableTableFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports